import PosterPlugin from './poster'
export default PosterPlugin



// WEBPACK FOOTER //
// ./src/plugins/poster/index.js